import styled from '@emotion/styled';
import { Css, Responsive } from '../../../ui';
import IAHBackground from '../../../assets/iah-phone-mask.png';
import HOUBackground from '../../../assets/hou-phone-mask.png';
import { Color } from '../../../styles/Color';
import { useCommonData } from '../../../common-data/useCommonData';
import { getMobileOperatingSystem } from '../../../utils/getMobileOperatingSystem';
import { FooterStoreLink } from './FooterStoreLink';
import { AirportCodes } from '../../../types/airports';
import {
	ISocialLinkItem,
	ISocialLinkItemPlatform,
	ISocialLinksProps,
} from '../social-links/SocialLinks';

export const FooterAppInfo = ({ links }: ISocialLinksProps) => {
	const { airportCode } = useCommonData();
	const isMobileXL = Responsive.useMatchesBreakpoint('mobileXL');
	const backgroundImage =
		airportCode === AirportCodes.IAH ? IAHBackground : HOUBackground;

	return (
		<StyledGridItem>
			<StyledAppInfo>
				<h5>Download our mobile app</h5>
				<StyledWrapper>
					<StyledBackground />
					<StyledRow>
						<StyledPhoneImg
							src={backgroundImage}
							alt="Preview of the mobile app"
							loading="lazy"
						/>
						{links && (
							<StyledColumn>{renderStoreLinks(links, isMobileXL)}</StyledColumn>
						)}
					</StyledRow>
				</StyledWrapper>
			</StyledAppInfo>
		</StyledGridItem>
	);
};

function renderStoreLinks(links: ISocialLinkItem[], isMobile = false) {
	let stores = links;
	const OS = getMobileOperatingSystem();
	if (isMobile && (OS === 'iOS' || 'Android')) {
		stores = links.filter(
			(link) =>
				link.platform ===
				(OS === 'iOS'
					? ISocialLinkItemPlatform.AppStore
					: ISocialLinkItemPlatform.GooglePlayStore),
		);
	}
	if (stores && stores.length > 0) {
		return <>{stores.map(FooterStoreLink)}</>;
	}
	return <></>;
}

const StyledGridItem = styled.div`
	padding: 0;
	display: flex;
	flex-direction: column;
	flex: 3;
	align-items: end;
	width: fit-content;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		align-items: start;
	}
`;

const StyledPhoneImg = styled.img`
	z-index: 2;
	position: relative;
	margin-left: 32px;
	height: ${Css.pxToRem(195)};
	margin-top: -${Css.pxToRem(195)};
	margin-bottom: ${Css.pxToRem(24)};
`;

const StyledWrapper = styled.div`
	overflow: hidden;
	max-height: ${Css.pxToRem(195)};
`;

const StyledBackground = styled.div`
	z-index: 1;
	position: relative;
	border-radius: 4px;
	margin-top: ${Css.pxToRem(35)};
	height: ${Css.pxToRem(160)};
	width: ${Css.pxToRem(312)};
	background-color: ${Color.Tertiary3};
`;

const StyledRow = styled.div`
	flex-direction: row;
	display: flex;
`;

const StyledColumn = styled.div`
	flex-direction: column;
	display: flex;

	gap: 16px;

	z-index: 2;
	margin-left: ${Css.pxToRem(24)};
	margin-top: -${Css.pxToRem(96)};

	a:nth-last-of-type(2) {
		margin-top: -${Css.pxToRem(24)};
	}
`;

const StyledAppInfo = styled.div`
	width: fit-content;
`;
